module.exports = __webpack_public_path__ + "static/media/ic-star-red.be309fa0.svg";